<div class="px-3 my-3">
  <form [formGroup]="formGroup!" class="mb-2">
    <app-input-container>
      <input
        class="form-control shadow-none"
        type="text"
        name="search"
        placeholder="{{ input.placeholder | msg | async }}"
        formControlName="{{ input.name }}"
      />
    </app-input-container>
  </form>

  <app-search-button-group (searchEvent)="onSearch()" (clearEvent)="onClear()">
  </app-search-button-group>
</div>
